import {Link} from 'react-router-dom'
import isPropValid from '@emotion/is-prop-valid'
import styled from '@emotion/styled'
import {css} from '@emotion/core'

import Button from '../../../designSystem/Button'
import {mq} from '../../../../utils/breakpoints'

import {
  MdDehaze as Dehaze,
  MdKeyboardArrowLeft as ChevronLeft
} from 'react-icons/md'
import {ThemeType} from 'types/Theme'
import {MOBILE_HEADER_HEIGHT} from './constants'

const ICON_SIZE = 48
const ETRIP_LOGO_SIZE = 32
const FINDHOTEL_LOGO_SIZE = 24
const VIO_LOGO_HEIGHT = 24
const VIO_LOGO_WIDTH = 38

const mirror = () => css`
  /* @mirror */
`

type HeaderElementProps = {
  theme?: ThemeType
  hasShadow: boolean
}

export const HeaderElement = styled('header')(
  ({theme, hasShadow}: HeaderElementProps) => css`
    display: flex;
    position: relative;
    align-items: center;
    text-align: center;
    justify-content: space-between;
    height: ${MOBILE_HEADER_HEIGHT}px;
    padding: ${theme.layout.spacing.s300}px ${theme.layout.spacing.s200}px;
    background-color: ${theme.colors.headerBgPrimary};

    ${mq.mobileLg(`padding: ${theme.layout.spacing.s300}px;`)}

    ${hasShadow &&
    `
      box-shadow: ${theme.shadows.action};
    `}
  `
)

const logoStyles = ({theme, brand, compact = false}) => css`
  height: auto;
  max-height: ${ICON_SIZE}px;
  width: auto;
  margin: 0;

  ${brand === 'vio'
    ? `padding: ${theme.layout.spacing.s200}px;`
    : `padding: ${theme.layout.spacing.s300}px;`}

  & > img {
    max-width: none;

    ${brand === 'etrip' && `height: ${ETRIP_LOGO_SIZE}px;`}
    ${brand === 'vio' && `max-height: ${VIO_LOGO_HEIGHT}px;`}
    ${brand === 'findhotel' &&
    `max-height: ${FINDHOTEL_LOGO_SIZE}px;
        margin-top: ${theme.layout.spacing.s200}px;`}
  }

  ${compact &&
  `
    width: ${ICON_SIZE}px;

    & > img {
      margin-top: unset;
      max-width: ${ICON_SIZE - theme.layout.spacing.s500}px;

      ${
        brand === 'vio'
          ? `max-width: ${VIO_LOGO_WIDTH}px;
          margin: 0;`
          : ``
      }
    }
  `}
`
export const LogoLinkElement = styled(Link, {shouldForwardProp: isPropValid})(
  logoStyles
)

export const LogoAnchorElement = styled('a', {shouldForwardProp: isPropValid})(
  logoStyles
)

export const LogoElement = styled('div')(logoStyles)

const backButtonBaseStyles = ({theme}) => css`
  padding: ${theme.layout.spacing.s300}px;
  width: ${ICON_SIZE}px;
  display: flex;
  justify-content: center;
  color: ${theme.colors.backButtonColorPrimary};
`
export const BackButtonElement = styled(Button)(backButtonBaseStyles, mirror)

export const BackIcon = styled(ChevronLeft)``

export const ContentWrapper = styled('div')(
  ({theme}) => css`
    flex: 1;
    min-width: 0;
    max-height: ${ICON_SIZE}px;
    overflow: hidden;
    padding: 0 ${theme.layout.spacing.s200}px;
    font-size: ${theme.fonts.size.md};
    font-weight: ${theme.fonts.weight.lg};
  `
)

export const AvatarWrapper = styled('div')<{isMemberPlus: boolean}>(
  ({theme, isMemberPlus}) => css`
    padding: ${isMemberPlus ? `${theme.layout.spacing.s200}px` : '0'};
    box-shadow: ${isMemberPlus
      ? `inset 0 0 0 1px ${theme.colors.violet.v300}`
      : 'none'};
    border-radius: 50%;
    position: relative;
  `
)

export const HamburgerElement = styled('div')(
  ({theme}) => css`
    padding: ${theme.layout.spacing.s400}px;
    height: auto;
    max-height: ${ICON_SIZE}px;
    margin: 0;
    color: ${theme.colors.hamburgerColorPrimary};
  `
)

export const HamburgerIcon = styled(Dehaze)(
  ({theme}) => css`
    margin: ${theme.layout.spacing.s100}px 1px 0;
  `
)

export const Spacer = styled('div')`
  width: ${ICON_SIZE}px;
`
